export default "__VITE_ASSET__ed377e26__"